export default __webpack_public_path__ + "static/media/cloud1.f7beb753.svg";